
<template>
  <div>
    <el-dialog :title="getTitle" top="50px" :visible.sync="dailogShow" width="50%" :close-on-click-modal="false" :before-close="handleClose" append-to-body @open="handleOpen">
      <el-form
        ref="entityData"
        :model="entityData"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
        label-position="right"
      >
        <el-row :gutter="20">
          <!-- 负责人 -->
          <el-col :span="24">
            <el-form-item prop="ketiFzrUserId" label="负责人">
              <el-select v-model="entityData.ketiFzrUserId" placeholder="课题负责人" clearable>
                <el-option
                  v-for="item in ketiMemberList"
                  :key="item.userKey"
                  :label="item.userName"
                  :value="item.userKey"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 课题名称 -->
          <el-col :span="24">
            <el-form-item prop="ketiMingcheng" label="课题名称">
              <el-input v-model="entityData.ketiMingcheng" maxlength="50" clearable />
            </el-form-item>
          </el-col>
          <!-- 课题编号 -->
          <el-col :span="24">
            <el-form-item prop="ketiBianhao" label="课题编号">
              <el-input v-model="entityData.ketiBianhao" maxlength="50" clearable />
            </el-form-item>
          </el-col>

          <!-- 经费来源 -->
          <el-col :span="24">
            <el-form-item prop="jingfeiLaiyuan" label="经费来源">
              <el-input v-model="entityData.jingfeiLaiyuan" maxlength="50" clearable />
            </el-form-item>
          </el-col>
          <!-- 经费卡号 -->
          <el-col :span="24">
            <el-form-item prop="jingfeiKahao" label="经费卡号">
              <el-input v-model="entityData.jingfeiKahao" maxlength="50" clearable />
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div class="dialog-footer">
        <el-button
          type="primary"
          @click="handleSave()"
        >
          保  存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
export default {
  components: {
  },
  props: {
    entityId: { type: Number, default: null }
  },
  data() {
    return {
      entityData: {},
      allComboxData: [],
      selectedValue: [],
      ketiMemberList: [],
      dailogShow: false,

      rules: {
        ketiFzrUserId: [{ required: true, message: '请选择负责人', trigger: 'change,blur' }],
        ketiMingcheng: [{ required: true, message: '请输入课题名称', trigger: 'change,blur' }],
        ketiBianhao: [{ required: true, message: '请输入课题编号', trigger: 'change,blur' }],
        jingfeiLaiyuan: [{ required: true, message: '请输入经费来源', trigger: 'change,blur' }],
        jingfeiKahao: [{ required: true, message: '请输入经费卡号', trigger: 'change,blur' }]
      }
    }
  },
  computed: {
    getTitle() {
      return (this.entityId ? '修改课题管理' : '新增课题管理')
    }
  },
  /** 创建 */
  created() {
    const that = this
    // 取得所有下拉框数据 逗号隔开
    const loading = this.$loading(KxjCom.loadOptions)
    pathReq.getForm('api/services/app/Com/GetKetizuMember').then(resp => {
      that.ketiMemberList = resp.data.result
      loading.close()
    })
  },
  activated() {
    this.init()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /**
     * 初始化数据
     */
    init() {
      // const path = '/api/services/app/zy0204/GetEditzy0204?Id=' + this.entityId
      // pathReq.getNoParams(path).then(res => {
      //   this.entityData = res.data.result.entityData
      // })
    },
    show() {
      this.dailogShow = true
    },
    handleClose() {
      this.$refs['entityData'].resetFields()
      this.dailogShow = false
    },
    handleOpen() {
      var path = '/api/services/app/zy0204/GetEditzy0204'
      if (this.entityId) {
        path += ('?Id=' + this.entityId)
      }
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result.entityData
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/zy0204/CreateOrUpdatezy0204'

          pathReq.postForm(path, { entityData: that.entityData }).then(() => {
            that.$message.success('保存成功')
          }).then(_ => {
            this.$emit('save-success')
            that.dailogShow = false
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
